/*eslint-disable*/
import api from '../'

class fourthOneGameApi {
    static getThemes () {
        return api.axios.get('/fourth-one/themes').then(response => response.data.themes);
    }

    static getItems (params) {
        return api.axios.post('/fourth-one/items', params).then(response => response.data);
    }
}

export default fourthOneGameApi;
